export default __webpack_public_path__ + "static/media/cadence.e284f629.webp";